import React, { useEffect } from "react";
import TeamMember from "./TeamMember";
import "./OurTeam.css";
import teamMembers from "./teamData";

const OurTeam = () => {
  useEffect(() => {
    const onScroll = () => {
      const photo = document.querySelector(".carousel");
      if (!photo) {
        return;
      }

      // Get Window Bottom
      const windowBottom = window.scrollY + window.innerHeight;
      const photoTop = photo.offsetTop;
      if (windowBottom > photoTop + 100) {
        photo.classList.remove("hidden");
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div className="OurTeam">
      <div className="carousel hidden">
        {teamMembers.map((member) => (
          <TeamMember
            key={member.slug}
            name={member.name}
            title={member.title}
            img={member.img}
            email={member.email}
            phone={member.phone}
            slug={member.slug}
          ></TeamMember>
        ))}
      </div>
    </div>
  );
};

export default OurTeam;
